import { html } from 'lit';
import { Story } from '../view-demoing.js';

export default {
  title: 'Example/Button',
  argTypes: {
    backgroundColor: { control: 'color' },
  },
};

interface Args {
  backgroundColor: string;
  text: string;
}

const Button: Story<Args> = ({ backgroundColor = 'white', text }) => html`
  <button type="button" style="background-color: ${backgroundColor}">
    ${text}
  </button>
`;

export const ButtonA = Button.bind({});
ButtonA.args = {
  text: 'Button A',
};

export const ButtonB = Button.bind({});
ButtonB.args = {
  text: 'Button B',
};
